import React from "react";
import { mediaUrl } from "@/lib/api";

const n2 = (v) => Number(v || 0).toFixed(2);
const Rule = () => <div style={{ borderTop: "1px dashed #000", margin: "4px 0" }} />;
const Row = ({ l, r, bold, size }) => (
  <div style={{ display: "flex", justifyContent: "space-between", gap: 6, fontWeight: bold ? 700 : 400, fontSize: size }}>
    <span>{l}</span><span style={{ whiteSpace: "nowrap" }}>{r}</span>
  </div>
);

// data: { items, subtotal, discount, discount_pct, total, vat, method, receipt_no, table, waiter, date, prebill, copy }
export function ReceiptDoc({ tpl, data }) {
  const L = tpl.labels, S = tpl.show, fs = Number(tpl.font_size) || 12;
  return (
    <div style={{ width: `${tpl.printable_mm}mm`, margin: "0 auto", padding: `${tpl.margin_mm}mm 0`, fontFamily: tpl.font_family,
      fontSize: fs, lineHeight: tpl.line_height, color: "#000", background: "#fff", wordBreak: "break-word" }}>
      {tpl.logo_enabled && tpl.logo_url && (
        <div style={{ textAlign: "center", marginBottom: 4 }}><img src={mediaUrl(tpl.logo_url)} alt="" style={{ width: `${tpl.logo_mm}mm`, maxWidth: "100%" }} /></div>
      )}
      {tpl.title && <div style={{ textAlign: "center", fontWeight: 700, fontSize: fs + 2 }}>{tpl.title}</div>}
      {tpl.subtitle && <div style={{ textAlign: "center", fontSize: fs - 1, whiteSpace: "pre-line" }}>{tpl.subtitle}</div>}
      {data.prebill && <div style={{ textAlign: "center", fontWeight: 700, marginTop: 4 }}>{L.prebill}</div>}
      {data.copy && <div style={{ textAlign: "center", fontWeight: 700, marginTop: 4 }}>*** {L.copy} ***</div>}
      <Rule />
      {S.receipt_no && data.receipt_no && <Row l={L.receipt} r={String(data.receipt_no).padStart(6, "0")} />}
      {S.datetime && <Row l={L.date} r={new Date(data.date || Date.now()).toLocaleString("bg-BG")} />}
      {S.table && <Row l={L.table} r={data.table} />}
      {S.waiter && data.waiter && <Row l={L.waiter} r={data.waiter} />}
      <Rule />
      {(data.items || []).map((i, k) => (
        <div key={k} style={{ marginBottom: 2 }}>
          <Row l={`${i.quantity} x ${i.name_bg || i.name}`} r={n2(i.price * i.quantity)} />
          {S.unit_price && i.quantity > 1 && <div style={{ fontSize: fs - 2 }}>  @ {n2(i.price)}</div>}
          {S.notes && i.note && <div style={{ fontSize: fs - 2 }}>  * {i.note}</div>}
        </div>
      ))}
      <Rule />
      {S.discount && data.discount > 0 && (<>
        <Row l={L.subtotal} r={n2(data.subtotal)} />
        <Row l={`${L.discount} ${data.discount_pct}%`} r={`-${n2(data.discount)}`} />
      </>)}
      <Row l={L.total} r={`${n2(data.total)} €`} bold size={fs + 3} />
      {S.vat && (data.vat || []).map((v) => <Row key={v.rate} l={`${L.vat} ${v.rate}%`} r={n2(v.vat)} size={fs - 1} />)}
      {S.payment && data.method && <Row l={L.payment} r={data.method === "CASH" ? L.cash : L.card} />}
      {(tpl.extra_lines || []).filter(Boolean).length > 0 && <Rule />}
      {(tpl.extra_lines || []).filter(Boolean).map((t, k) => <div key={k} style={{ textAlign: "center" }}>{t}</div>)}
      <Rule />
      {S.nonfiscal_note && <div style={{ textAlign: "center", fontSize: fs - 2 }}>{L.nonfiscal}</div>}
      {S.footer && tpl.footer && <div style={{ textAlign: "center", marginTop: 2, whiteSpace: "pre-line" }}>{tpl.footer}</div>}
      <div style={{ height: "6mm" }} />
    </div>
  );
}

export const receiptFromOrder = (order, { prebill = false, copy = false } = {}) => {
  const p = order.payment || {};
  return {
    items: order.items || [], subtotal: p.subtotal ?? order.total, discount: p.discount || 0, discount_pct: p.discount_pct || 0,
    total: p.amount ?? order.total, vat: p.vat || [], method: prebill ? null : p.method, receipt_no: prebill ? null : p.receipt_no,
    table: order.table_number, waiter: order.waitress_name, date: prebill ? Date.now() : (p.created_at || order.closed_at), prebill, copy,
  };
};

export const SAMPLE_RECEIPT = {
  items: [{ name_bg: "Шопска салата", quantity: 2, price: 6.5, note: "Без лук" }, { name_bg: "Кебапче", quantity: 3, price: 2.2 }, { name_bg: "Кафе", quantity: 1, price: 2 }],
  subtotal: 21.6, discount: 2.16, discount_pct: 10, total: 19.44, vat: [{ rate: 20, vat: 3.24 }], method: "CASH",
  receipt_no: 123, table: "5", waiter: "Мария", date: Date.now(),
};
